import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import VueCodemirror from 'vue-codemirror'

// language
import 'codemirror/mode/xml/xml.js'
// theme css
import 'codemirror/theme/base16-dark.css'
// require active-line.js
import 'codemirror/addon/selection/active-line.js'
// autoCloseTags
import 'codemirror/addon/edit/closetag.js'
// require more codemirror resource...

Vue.config.productionTip = false;


// you can set default global options and events when use
Vue.use(VueCodemirror, {
  options: {
    tabSize: 4,
    styleActiveLine: true,
    lineNumbers: true,
    autoCloseTags: true,
    line: true,
    mode: 'text/html',
    theme: 'base16-dark',
    readOnly: true,
    viewportMargin: Infinity
  }
})

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.component('VueSlider', VueSlider)

const components = require('./components');
for (let key in components) {
  Vue.component(key, components[key]);
}

const interComps = require('./views/components');
for (let key in interComps) {
  Vue.component(key, interComps[key]);
}

const featherIcons = require('vue-feather-icons');
Object.keys(featherIcons).forEach((key) => {
  const icon = featherIcons[key];
  Vue.component(key, icon);
});

const { icons } = require('./util/vendors/feather.min');
Object.keys(icons).forEach((key) => {
  const icon = icons[key];
  store.state.featherIcons.push(icon.name);
});




new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


